import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/contract-set',
      name: 'admin-contract-set',
      component: () => import(/* webpackChunkName: "page-admin-supplier-management-contract-set" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "合同信息设置"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "供应商管理"
                                        },
                                        {
                                                  name: "添加供应商"
                                        },
                                        {
                                                  name: "合同信息设置"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
